<ul class="child-node-wrapper">
    <li
        *ngFor="let node of childrenNodes"
        class="child-node"
        [ngClass]="{ 'first-level': firstLevel }"
    >
        <app-link
            class="child-node-title {{
                gtmPrefix
            }}-child-navigation-node selenium-child-navigation-node"
            [attr.data-gtmlabel]="node.title"
            [appRouterLink]="getNodeRouterLink(node)"
            [ngClass]="{ 'active-node': isActive(node) }"
            [ngStyle]="getBackgroundColor(node)"
        >
            <span class="title" [innerHTML]="node.title"></span>
            <span
                (click)="expandNode($event, node)"
                class="icon"
                *ngIf="node.children.length"
                [ngStyle]="getDetailColor(node)"
            >
                <i
                    *ngIf="!expandedNodes[node.id]"
                    class="fas fa-plus {{
                        gtmPrefix
                    }}-child-navigation-node-expand selenium-child-navigation-node-expand"
                    [attr.data-gtmlabel]="node.title"
                >
                </i>
                <i
                    *ngIf="expandedNodes[node.id]"
                    class="fas fa-minus {{
                        gtmPrefix
                    }}-child-navigation-node-collapse selenium-child-navigation-node-collapse"
                    [attr.data-gtmlabel]="node.title"
                >
                </i>
            </span>
        </app-link>
        <div *ngIf="node.children.length && expandedNodes[node.id]" class="child-node-children">
            <app-side-navigation-nodes
                [childrenNodes]="node.children"
                [activeNode]="activeNode"
                [gtmPrefix]="gtmPrefix"
                [styles]="styles"
            >
            </app-side-navigation-nodes>
        </div>
    </li>
</ul>
